// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"139":"a5c040a14581ac12","351":"ef550c80550aff1c","2180":"172a7fec2898fdb5","6220":"0e785b558a2c0b64","6281":"d500b872173011eb"}[chunkId] + ".css";
};